export const CALIBRATION_STATES = {
	Created: 'Created',
	StartSent: 'Start Sent',
	Calibrating: 'Calibrating',
	StopSent: 'Stop Sent',
	Stopped: 'Stopped',
};
